// Ticket 28: Most Loved List Component
import React, { useEffect, useState } from 'react';
import { fetchMostLoved } from '../api/leaderboard';
import { useNavigate } from 'react-router-dom';
import EliteBadge from './elite/EliteBadge';

const MostLovedList = ({ range }) => {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    let cancelled = false;

    const loadData = async () => {
      try {
        setLoading(true);
        setError(null);
        const data = await fetchMostLoved(range);
        if (!cancelled) {
          setItems(data.items || []);
        }
      } catch (err) {
        console.error('[MostLoved] Failed to load:', err);
        if (!cancelled) {
          setError('Unable to load most loved');
        }
      } finally {
        if (!cancelled) {
          setLoading(false);
        }
      }
    };

    loadData();

    return () => {
      cancelled = true;
    };
  }, [range]);

  if (loading && !items.length) {
    return (
      <div className="mt-4 text-center text-xs text-slate-400">Loading most loved...</div>
    );
  }

  if (error) {
    return (
      <div className="mt-4 rounded-xl bg-red-900/40 px-4 py-3 text-xs text-red-200">
        {error}
      </div>
    );
  }

  if (!items.length) {
    return (
      <div className="mt-4 rounded-xl bg-slate-800/80 border border-slate-700/50 px-4 py-4 text-xs text-slate-300">
        No gifts received yet for this range.
      </div>
    );
  }

  return (
    <div className="mt-2 flex flex-col gap-2">
      {items.map((item) => (
        <button
          key={item.user_id}
          onClick={() => navigate(`/profile/${item.user_id}`)}
          className="flex items-center justify-between rounded-2xl bg-slate-800/80 border border-slate-700/50 px-3 py-2 text-xs text-slate-100 hover:bg-slate-700/80 transition-colors"
        >
          <div className="flex items-center gap-3">
            {/* Rank Badge */}
            <div className="flex h-7 w-7 items-center justify-center rounded-full bg-gradient-rose-gold text-[11px] font-bold text-white">
              {item.rank}
            </div>
            
            {/* Avatar & Info */}
            <div className="flex items-center gap-2">
              <div className="h-8 w-8 overflow-hidden rounded-full bg-slate-800">
                {item.avatar ? (
                  <img
                    src={item.avatar}
                    alt={item.name}
                    className="h-full w-full object-cover"
                  />
                ) : (
                  <span className="flex h-full w-full items-center justify-center text-[11px]">
                    {item.name?.[0]?.toUpperCase() || '?'}
                  </span>
                )}
              </div>
              <div className="flex flex-col items-start">
                <div className="flex items-center gap-1.5">
                  <span className="text-[11px] font-semibold">{item.name}</span>
                  {item.is_elite && <EliteBadge size="sm" showLabel={false} />}
                </div>
                <span className="text-[10px] text-slate-400">
                  {item.total_gifts_received} gifts • {item.unique_gifters} gifters
                </span>
              </div>
            </div>
          </div>
          <span className="text-[10px] text-pink-300">View →</span>
        </button>
      ))}
    </div>
  );
};

export default MostLovedList;
